module.exports = __webpack_public_path__ + "static/aviso-9d31cf5cccc5806e296128522b341091.pdf";